import Dropdown from 'antd/lib/dropdown'
import 'antd/lib/dropdown/style/index.css'

export default Dropdown



// WEBPACK FOOTER //
// ./src/elements/dropdown/index.js